<script lang="ts">
	import type { ClassValue, HTMLTextareaAttributes } from "svelte/elements";
	import { updateTextareaHeight } from "@core/utils/updateTextareaHeight.js";

	const { wrapperClass, ...rest }: HTMLTextareaAttributes & { wrapperClass?: ClassValue } = $props();

	let errorMessage = $state("");

	function validate({ currentTarget }: Event & { currentTarget: EventTarget & HTMLTextAreaElement }): void {
		if (currentTarget.validity.valid) {
			errorMessage = "";
		} else {
			errorMessage = currentTarget.validationMessage;
		}
	}
</script>

<div class={["flex flex-col w-full", wrapperClass]}>
	<textarea
		use:updateTextareaHeight
		{...rest}
		class={[
			"font-semibold md:text-[1.125rem]/[1.2] p-2 md:p-7 focus:border-zms-blue [&:user-invalid]:border-red-300 [&:user-invalid]:outline-red-300 focus:[&:user-invalid]:border-red-300 focus:[&:user-invalid]:outline-red-300 focus:text-zms-optical-black overflow-auto text-[#595959] min-w-0 border resize-none shadow-sm border-[#D7D7D7] rounded-[.25rem] min-h-[12rem] transition-[outline,text,border] duration-300 outline-transparent outline-1 outline outline-offset-1",
			rest.class,
		]}
		oninput={(event: Event & { currentTarget: EventTarget & HTMLTextAreaElement }): void => {
			validate(event);
			rest.oninput?.(event);
		}}
		oninvalid={(event: Event & { currentTarget: EventTarget & HTMLTextAreaElement }): void => {
			event.preventDefault();
			validate(event);
			rest.oninvalid?.(event);
		}}
	></textarea>
	{#if errorMessage}
		<span class="text-red-500 text-xs mt-1">{errorMessage}</span>
	{/if}
</div>
